import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pick',
    standalone: false
})
export class PickPipe implements PipeTransform {
  transform(value: any[], attr: string): any {
    return value.map(itm => itm[attr]);
  }
}